import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextTitle from "apps/website/components/base/Text/TextTitle/TextTitle";
import {
  vetsAndExpertsData,
} from "apps/website/components/feature/Carousel/VetsAndExpertsCardCarousel/shared/vetsAndExpertsData";
import VetsAndExpertsCardCarousel from "apps/website/components/feature/Carousel/VetsAndExpertsCardCarousel/VetsAndExpertsCardCarousel";
import Container from "apps/website/components/layout/Container/Container";
import Section from "apps/website/components/layout/Section/Section";
import Spacer from "apps/website/components/layout/Spacer/Spacer";

export default function SectionExpertBacked() {
  return (
    <Section component="SectionExpertBacked" size="lg">
      <Container >

        <div className="flex flex-col gap-2 mb-6 md:gap-8 md:mb-8">
          <TextTitle size={1} align="center" className="uppercase">Backed by vets and experts</TextTitle>
          <TextSubtitle size={1} align="center">It&apos;s what they feed their cats too.</TextSubtitle>
          <Spacer size="lg" />
        </div>
        <Container padding="none">
          <VetsAndExpertsCardCarousel items={vetsAndExpertsData} />
        </Container>
      </Container>
    </Section>
  );
}
